<template>
  <b-modal :id="`formImpressao`"
           :ref="`formImpressao`"
           header-class="modalImpressao_header"
           no-close-on-backdrop
           size="xl"
           no-close-on-esc
           hide-footer
           visible>
    <div slot="modal-header"
         class="modalImpressao_title w-100">
      Imprimir livro-caixa
    </div>
    <div class="ImpressaoLivroCaixa">
      <div class="ImpressaoLivroCaixa_header px-3 py-2">
        <div class="row">
          <div class="col-3">
            <b-form-checkbox
              v-model="localData.balancete"
              v-validate="'required'"
              switch
              :value="true"
              class="ImpressaoLivroCaixa_label mt-1"
              @change="clearFilter()">
              Imprimir balancete
            </b-form-checkbox>

            <b-form-checkbox
              v-model="localData.frente_verso"
              switch
              :value="true"
              class="ImpressaoLivroCaixa_label mt-2">
              Usar frente e verso
            </b-form-checkbox>
          </div>
          <div class="col-3">
            <div class="tooltipHelpNumLivro"
                 data-tooltip="Defina o número do livro-caixa que está sendo utilizado em seu cartório para essa impressão.">
              <label for="num_livro_relatorio_livro_caixa"
                     class="ImpressaoLivroCaixa_label">Número do livro</label>

              <icon-svg icon="helpCircle"
                        class="icon--sm ml-2"
                        style="fill: #074f7f !important;" />
            </div>

            <input id="num_livro_relatorio_livro_caixa"
                   v-model="localData.num_livro"
                   v-validate="'required'"
                   required
                   type="number"
                   min="1"
                   name="num_livro_relatorio_livro_caixa"
                   placeholder="0000"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('num_livro_relatorio_livro_caixa')}"
                   :disabled="!!localData.balancete">
            <span v-if="errors.has('inicio')"
                  class="invalid-feedback">
              {{ !localData.num_livro ? 'Campo obrigatório' : errors.first("num_livro_relatorio_livro_caixa") }}
            </span>
          </div>
          <div class="col-3">
            <div class="tooltipHelpNumFolhaInicial"
                 data-tooltip="Defina o número da folha inicial para essa impressão.">
              <label for="num_folha_inicial"
                     class="ImpressaoLivroCaixa_label">Número da folha inicial</label>
              <icon-svg icon="helpCircle"
                        class="icon--sm ml-2"
                        style="fill: #074f7f !important;" />
            </div>

            <input id="num_folha_inicial"
                   v-model="localData.num_folha_inicial"
                   v-validate="'required'"
                   required
                   type="number"
                   min="1"
                   name="num_folha_inicial"
                   placeholder="0000"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('num_folha_inicial')}"
                   :disabled="!!localData.balancete">
            <span v-if="errors.has('inicio')"
                  class="invalid-feedback">
              {{ !localData.num_folha_inicial ? 'Campo obrigatório' : errors.first("num_folha_inicial") }}
            </span>
          </div>
          <div class="col-3">
            <label class="ImpressaoLivroCaixa_label">
              Lado inicial
            </label>
            <select v-model="localData.lado_inicial"
                    class="custom-select custom-select-sm"
                    name="lado_inicial"
                    :disabled="!localData.frente_verso">
              <option v-for="lado in lados_iniciais"
                      :key="lado"
                      :value="lado">
                {{ lado }}
              </option>
            </select>
          </div>
        </div>
      </div>
    <!-- Exibicao do PDF no modal
        <div class="ImpressaoLivroCaixa_body">
          <object v-if="pdfUrl != null"
                  class="document-preview embed-responsive"
                  :data="`${ pdfUrl }`"
                  type="application/pdf">
            <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
          </object>
        </div> -->
    </div>

    <div 
      class="d-flex justify-content-end mt-2 py-2 border-top solid">
      <button class="btn btn-sm btn-dark mr-2"
              @click="hide()">
        Cancelar
      </button>
      
      <button class="btn btn-sm btn-secondary"
              type="submit"
              :disabled="(!localData.num_livro || !localData.num_folha_inicial) && !localData.balancete"
              @click="getRelatorio('PDF')">
        <icon-svg icon="print"
                  class="icon--xs icons--white" />
        Imprimir
      </button>

      <button class="btn btn-sm btn-success ml-2"
              type="button"
              :disabled="(!localData.num_livro || !localData.num_folha_inicial) && !localData.balancete"
              @click="getRelatorio('EXCEL')">
        <icon-svg icon="download"
                  class="icon--xs icons--white" />
        Exportar Excel
      </button>
    </div>

    <object v-if="pdfUrl"
            class="document-preview embed-responsive"
            :data="pdfUrl"
            type="application/pdf">
      <p>Seu navegador não suporta arquivos PDF diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
    </object>
  </b-modal>
</template>

<script>
  // Services
  import LivroCaixaService from "@/services/LivroCaixaService"

  import moment from 'moment'

  export default {
    name: 'ImpressaoLivroCaixa',
    props: {
      propData: { type: Object, default: null},
    },
    data () {
      return {
        localData: {
          balancete: false,
          num_livro: null,
          num_folha_inicial: null,
          filtro: null,
          data_inicial: null,
          data_final: null,
          tipo_relatorio: 'PDF', // PDF ou EXCEL,
          frente_verso: false,
          lado_inicial: 'Frente',
        },
        pdfUrl: null,
        lados_iniciais: ['Frente', 'Verso']
      }
    },
    mounted () {
      if (this.propData) {
        this.localData.data_inicial = this.propData.data_inicial ? this.propData.data_inicial : null
        this.localData.data_final = this.propData.data_final ? this.propData.data_final : null
        this.localData.filtro = this.propData.tipo

        // Para relatório de despesas trazemos como sugestão a impressão de balancete
        if (this.propData.tipo && this.propData.tipo.length == 1 && this.propData.tipo[0] == 'DESPESA' ) {
          this.localData.balancete = true
          setTimeout(() => {
            this.getRelatorio('PDF')
          }, 200)  
        }
      }

    },
    methods: {
      async getRelatorio (tipoRelatorio = 'PDF') {
        try {
          const valid = await this.$validator.validateAll()

          if (!valid) return

          loader({ active: true, text: 'Buscando...' })

          this.localData.tipo_relatorio = tipoRelatorio
          const res = await LivroCaixaService.relatorioLivroCaixa(this.localData)

          if (tipoRelatorio === 'PDF') {
            this.pdfUrl = res 
          }

          if (tipoRelatorio === 'EXCEL') {
            const blob = new Blob([res.data], {type: res.headers['content-type']})
            const link = document.createElement('a')

            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', `${this.localData.balancete ? 'Balancete - ' : ''}Livro Caixa ${moment(this.localData.data_inicial).format('DD/MM/YYYY')} até ` + moment(this.localData.data_final).format('DD/MM/YYYY') + '.xlsx')
            document.body.appendChild(link)

            link.click()
            document.body.removeChild(link)
          }
        } catch (erro) {
          console.error(erro)
          displayMessage('error', '', erro.response.data.message || 'Não foi possível imprimir o livro caixa')
        } finally {
          loader({ active: false, text: '' })
        }
      },
      openUrl () {
        window.open(this.pdfUrl)
      },
      exportPDF () {
        this.localData.tipo_relatorio = 'EXCEL'

        return this.getRelatorio('EXCEL')
      },
      hide () {
        this.$emit('hide')
      },
      clearFilter () {
        this.localData.balancete = !this.localData.balancete

        if (this.localData.balancete) {
          this.localData.num_livro = null
          this.localData.num_folha_inicial = null
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  .ImpressaoLivroCaixa {
    &_label {
        font-size: 15px;
        font-weight: 500;
        color: #373a3c;
      }
  }
  .overflow-container {
  overflow-x: auto; /* Adiciona a barra de rolagem horizontal conforme necessário */
  white-space: nowrap; /* Impede que o conteúdo seja quebrado em várias linhas */
}
  .document-preview {
    height: 800px !important;
  }
  .modalImpressao{
    &_title{
    background-color: #074f7f;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.625rem 1.25rem;
    }

    &_header{
      padding: 0 0;
    }
  }
  .icon-print {
    fill: #1c7af5 !important;
    width: 18px;
    height: 18px;
    transition: fill 0.2s;
  }
  .btn_print:hover:not(:disabled) > [class*=icon-print] {
    fill: #fff !important;
  }

  .tooltipHelpNumLivro::before,
  .tooltipHelpNumLivro::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform-origin: bottom center;
    transform: translateX(0%) translateY(60%) scale(var(--scale));
  }

  .tooltipHelpNumLivro::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 130%;
    color: black;
    border-radius: .7rem;
    word-wrap: break-word;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  }

  .tooltipHelpNumLivro:hover::before,
  .tooltipHelpNumLivro:hover::after {
    --scale: 1;
  }

  .tooltipHelpNumLivro:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: solid;
    box-shadow: 0px 10px 20px 10;
    border-width: 0px 10px 20px 10px;
    transform: translateX(-110%) translateY(-165%) scale(var(--scale));
    border-color: transparent transparent var(--tooltip-color) transparent;
    -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  }

  .tooltipHelpNumFolhaInicial::before,
  .tooltipHelpNumFolhaInicial::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform-origin: bottom center;
    transform: translateX(0%) translateY(45%) scale(var(--scale));
  }

  .tooltipHelpNumFolhaInicial::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 130%;
    color: black;
    border-radius: .7rem;
    word-wrap: break-word;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  }

  .tooltipHelpNumFolhaInicial:hover::before,
  .tooltipHelpNumFolhaInicial:hover::after {
    --scale: 1;
  }

  .tooltipHelpNumFolhaInicial:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: solid;
    box-shadow: 0px 10px 20px 10;
    border-width: 0px 10px 20px 10px;
    transform: translateX(-110%) translateY(-165%) scale(var(--scale));
    border-color: transparent transparent var(--tooltip-color) transparent;
    -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  }
</style>
